import useSelectedSector from "hooks/useSelectedSector";
import TravelOfferService from "services/TravelOfferService";
import { Ride } from "types/Ride";
import ActiveRideMap from "./components/ActiveRideMap";
import React from "react";
import RideCard from "./components/RideCard";
import { Grid, IconButton } from "@mui/material";
import { Refresh } from "@mui/icons-material";
import LoadingBox from "components/common/LoadingBox/LoadingBox";
import TravelOfferDetailsModal from "./components/TravelOfferDetailsModal";

export const ActiveRidesList = () => {
  const { selectedSectorId } = useSelectedSector();
  const { data: rides, refetch, isFetching } = TravelOfferService.useGetActiveRidesQuery(selectedSectorId);
  const [selectedRide, setSelectedRide] = React.useState<Ride | null>(null);
  const [showModal, setShowModal] = React.useState<boolean>(false);

  const handleClickRide = (ride: Ride) => {
    setSelectedRide(ride);
  };

  return (
    <Grid container xl>
      <Grid container>
        <Grid item xs={12} md={6}>
          <IconButton onClick={() => refetch()} disabled={isFetching}>
            <Refresh />
          </IconButton>
          {isFetching && <LoadingBox />}
          {rides?.map((ride) => (
            <RideCard
              key={ride.id}
              ride={ride}
              onClick={() => handleClickRide(ride)}
              onEyeClick={() => {
                setSelectedRide(ride);
                setShowModal(true);
              }}
            />
          ))}
        </Grid>
        <Grid item xs={12} md={6}>
          {selectedRide && <ActiveRideMap ride={selectedRide} />}
        </Grid>
      </Grid>
      <TravelOfferDetailsModal
        open={showModal}
        travelOffer={selectedRide?.driverOffer?.travelOffer || null}
        ride={selectedRide || undefined}
        onClose={() => setShowModal(false)}
      />
    </Grid>
  );
};
